import { EditorProps } from '../DolEditor/types';
import { ExerciseMultipleChoiceOptions } from './plugins/ExerciseMultipleChoice/types';

export interface BlogEditorProps
  extends EditorProps,
    Pick<ExerciseMultipleChoiceOptions, 'onBackWhenInComplete'> {
  isReadOnly?: boolean;
  renderTopBar?: () => JSX.Element;
  overrideToolbar?: string[];
  leftSideBarButtonGroups?: any;
  contextMenuButtons?: any;
}

export const PluginPresetEnum = {
  ADS: 'ADS',
  TEXT_FORMAT: 'TEXT_FORMAT',
  BLOCK_FORMAT: 'BLOCK_FORMAT',
  HTML_OBJECT: 'HTML_OBJECT',
  MEDIA_OBJECT: 'MEDIA_OBJECT',
  DIVIDER: 'DIVIDER',
  EXERCISE_OBJECT: 'EXERCISE_OBJECT',
  SPECIAL_OBJECT: 'SPECIAL_OBJECT',
  HEADING: 'HEADING',
  CORE_PARAGRAPH_AT_END: 'CORE_PARAGRAPH_AT_END',
  CORE_PLACEHOLDER_FOR_NODE: 'CORE_PLACEHOLDER_FOR_NODE',
  HYPER_LINK: 'HYPER_LINK',
} as const;
export type PluginPresetEnum = (typeof PluginPresetEnum)[keyof typeof PluginPresetEnum];
